export default __webpack_public_path__ + "328fa8010d013564396830b555e65bb1.png";